/* ============================================================
   Nordstealth — Warenkorb

   Vier Aufgaben:

   1. Mengen aendern und Positionen entfernen. Bewusst in eigener
      Hand statt ueber das Theme-Buendel: das laedt aus der Ferne
      (js.shrinetheme.com), kann sich ohne Vorwarnung aendern und
      traegt einen Datumsschalter in sich. Die Ereignisse werden in
      der Capture-Phase abgefangen und gestoppt, damit nicht zwei
      Mechaniken gleichzeitig dieselbe Zeile aendern.
   2. Ergaenzungs-Karte (Gear-Dock) legt den Artikel nach.
   3. Reservierungsuhr, pro Sitzung statt pro Seitenaufruf.
   4. Abschlussbalken einblenden, sobald der Kassenknopf aus dem
      Bild ist — und wieder wegnehmen, sobald der Seitenfuss kommt.

   Zum Messen: auf ecyy6d-1v.myshopify.com leitet Shopify jede
   Anfrage ohne _fd=0 auf die eigene Domain um; ein fetch scheitert
   dann an CORS. Deshalb haengt dieser Code den Parameter auf
   myshopify-Hosts selbst an. Auf nordstealth.com aendert das nichts.
   ============================================================ */
(function () {
  'use strict';

  if (!document.querySelector('.ns-cart-main')) return;

  var spur = (window.__nsCart = { version: 1, schritte: [] });
  function log(x) {
    spur.schritte.push(x);
    if (spur.schritte.length > 40) spur.schritte.shift();
  }

  var ITEMS = '#main-cart-items';
  var FOOTER = '#main-cart-footer';
  var q = function (s, r) { return (r || document).querySelector(s); };

  // Auf der internen Domain haengt Shopify sonst eine Umleitung davor.
  function pfad(p) {
    if (!/\.myshopify\.com$/.test(location.hostname)) return p;
    return p + (p.indexOf('?') >= 0 ? '&' : '?') + '_fd=0';
  }

  function sektionen() {
    var a = q(ITEMS);
    var b = q(FOOTER);
    return { items: a && a.dataset.id, footer: b && b.dataset.id, bubble: 'cart-icon-bubble' };
  }

  function innenVon(html, selektor) {
    if (typeof html !== 'string') return null;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var el = doc.querySelector(selektor);
    return el ? el.innerHTML : null;
  }

  function laden(zeile, an) {
    var row = document.getElementById('CartItem-' + zeile);
    if (!row) return;
    var ov = row.querySelector('.loading-overlay');
    if (ov) ov.classList.toggle('hidden', !an);
  }

  function fehler(zeile, text) {
    var box = document.getElementById('Line-item-error-' + zeile);
    if (!box) return;
    var t = box.querySelector('.cart-item__error-text');
    if (t) t.textContent = text || '';
  }

  /* ---------- 1. Menge aendern ---------- */
  var laeuft = false;

  function zeileAendern(zeile, menge) {
    log('aendern ' + zeile + '->' + menge + (laeuft ? ' (blockiert)' : ''));
    if (laeuft) return;
    laeuft = true;
    laden(zeile, true);
    fehler(zeile, '');

    var ids = sektionen();
    var gewuenscht = [ids.items, ids.footer, ids.bubble].filter(Boolean);

    fetch(pfad('/cart/change'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        line: zeile,
        quantity: menge,
        sections: gewuenscht,
        sections_url: window.location.pathname,
      }),
    })
      .then(function (r) { return r.text(); })
      .then(function (text) {
        var daten = JSON.parse(text);
        log('antwort n=' + daten.item_count + ' sektionen=' + (daten.sections ? Object.keys(daten.sections).length : 0));
        if (daten.errors) { fehler(zeile, daten.errors); return null; }
        if (!daten.sections) {
          return fetch(pfad('/cart?sections=' + gewuenscht.join(',')))
            .then(function (r) { return r.json(); })
            .then(function (s) { daten.sections = s; return daten; });
        }
        return daten;
      })
      .then(function (daten) {
        if (!daten || !daten.sections) { log('nichts anzuwenden'); return; }
        anwenden(daten);
      })
      .catch(function (err) {
        log('fehler ' + String(err).slice(0, 60) + ' -> neu laden');
        window.location.assign(window.location.pathname + window.location.search);
      })
      .finally(function () {
        laeuft = false;
        laden(zeile, false);
      });
  }

  function anwenden(daten) {
    var ids = sektionen();
    var leer = daten.item_count === 0;

    var itemsHtml = innenVon(daten.sections[ids.items], '.js-contents');
    var footerHtml = innenVon(daten.sections[ids.footer], '.js-contents');
    log('anwenden items=' + (itemsHtml === null ? 'null' : itemsHtml.length) + ' footer=' + (footerHtml === null ? 'null' : footerHtml.length));

    if (itemsHtml !== null) q('.js-contents', q(ITEMS)).innerHTML = itemsHtml;
    if (footerHtml !== null) q('.js-contents', q(FOOTER)).innerHTML = footerHtml;

    var bubbleHtml = innenVon(daten.sections[ids.bubble], '.shopify-section');
    var bubble = document.getElementById('cart-icon-bubble');
    if (bubble && bubbleHtml !== null) bubble.innerHTML = bubbleHtml;

    var host = q('cart-items');
    if (host) host.classList.toggle('is-empty', leer);
    var fuss = q(FOOTER);
    if (fuss) fuss.classList.toggle('is-empty', leer);

    // Die Kopfzeile steht ausserhalb von .js-contents. Ihre frische
    // Fassung reist unsichtbar im ausgetauschten Bereich mit.
    var quelle = q('[data-ns-count-src]');
    var kopf = q('.ns-cart__count');
    if (quelle && kopf) kopf.innerHTML = quelle.innerHTML;

    balkenBeobachten();
  }

  document.addEventListener(
    'change',
    function (e) {
      var input = e.target.closest ? e.target.closest('.quantity__input') : null;
      if (!input || !input.closest(ITEMS)) return;
      log('change abgefangen');
      e.stopPropagation();
      zeileAendern(Number(input.dataset.index), Math.max(0, parseInt(input.value, 10) || 0));
    },
    true
  );

  document.addEventListener(
    'click',
    function (e) {
      var rm = e.target.closest ? e.target.closest('cart-remove-button') : null;
      if (!rm || !rm.closest(ITEMS)) return;
      e.preventDefault();
      e.stopPropagation();
      zeileAendern(Number(rm.dataset.index), 0);
    },
    true
  );

  /* ---------- 2. Ergaenzung nachlegen ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-ns-add]') : null;
    if (!btn || btn.disabled) return;
    e.preventDefault();

    var zeile = btn.getAttribute('data-line');
    var beschriftung = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Wird ergänzt…';

    // Liegt der Artikel schon im Korb, ist es nur eine neue Zielmenge —
    // dieselbe Mechanik wie die Plus-Taste, ohne Neuladen.
    if (zeile) {
      zeileAendern(Number(zeile), Number(btn.getAttribute('data-target')) || 1);
      return;
    }

    fetch(pfad('/cart/add.js'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(btn.getAttribute('data-variant')), quantity: 1 }] }),
    })
      .then(function (r) {
        if (!r.ok) throw new Error('nicht hinzugefuegt');
        return r.json();
      })
      .then(function () { window.location.assign(window.location.pathname + window.location.search); })
      .catch(function () {
        btn.disabled = false;
        btn.textContent = beschriftung;
      });
  });

  /* ---------- 3. Reservierungsuhr, sie laeuft genau EINMAL ----------
     Entscheidung des Haendlers vom 07.09.2026. Bis dahin setzte uhr() nach
     Ablauf das Ende still neu: die Anzeige sprang vor den Augen des Kunden
     von 0:00 zurueck auf 10:00 und behauptete damit eine zweite
     Reservierung, die es nie gab - reserviert wird ohnehin nichts.
     Jetzt verschwindet der Countdown nach Ablauf, das Intervall wird
     gestoppt, und die Zeile "Warenkorb gesichert" bleibt allein stehen.
     Kein Zuruecksetzen, auch nicht beim Neuladen: das abgelaufene Ende
     steht im sessionStorage und faellt beim naechsten Aufruf sofort wieder
     in denselben Zweig.
     Die Zeile verrutscht dabei nicht. .ns-sum__secure ist ein Flex-Kasten,
     in dem der Text auf flex: 1 1 auto steht und links am Symbol klebt;
     faellt die Uhr rechts weg, waechst nur der leere Raum dahinter. */
  var KEY = 'ns-cart-deadline';
  var uhrTakt = null;
  function zwei(n) { return n < 10 ? '0' + n : '' + n; }

  function uhr() {
    var box = q('[data-ns-cart-timer]');
    var out = q('[data-ns-cart-clock]');
    if (!box || !out) return;

    var spanne = (parseInt(box.getAttribute('data-minutes'), 10) || 10) * 60000;
    var ende = parseInt(sessionStorage.getItem(KEY), 10);

    if (!ende || isNaN(ende) || ende - Date.now() > spanne) {
      ende = Date.now() + spanne;
      sessionStorage.setItem(KEY, String(ende));
    }

    var rest = Math.round((ende - Date.now()) / 1000);
    if (rest <= 0) {
      // Abgelaufen: die Uhr geht, die Zusage bleibt. Es wird nichts
      // geloescht und nichts neu behauptet.
      var pille = out.closest ? out.closest('.ns-sum__clock') : null;
      if (pille && pille.parentNode) pille.parentNode.removeChild(pille);
      else out.textContent = '';
      if (uhrTakt) { clearInterval(uhrTakt); uhrTakt = null; }
      return;
    }
    out.textContent = Math.floor(rest / 60) + ':' + zwei(rest % 60);
  }

  // War die Frist schon beim Seitenaufbau abgelaufen, hat der erste Aufruf
  // die Uhr bereits entfernt - dann faengt gar kein Takt an zu laufen.
  uhr();
  if (q('[data-ns-cart-clock]')) uhrTakt = setInterval(uhr, 1000);

  /* ---------- 4. Abschlussbalken ---------- */
  var io = null;
  var ctaWeg = false;
  var fussDa = false;

  function balken() {
    var bar = q('[data-ns-mbar]');
    if (bar) bar.classList.toggle('is-on', ctaWeg && !fussDa);
  }

  function balkenBeobachten() {
    var bar = q('[data-ns-mbar]');
    if (!bar) return;

    var gesamt = q('.ns-sum__row--total .ns-sum__big');
    var ziel = q('[data-ns-mbar-total]');
    if (gesamt && ziel) ziel.textContent = gesamt.textContent.trim();

    var hinweis = q('[data-ns-mbar-note]');
    if (hinweis) {
      var frei = q('.ns-sum__row--free');
      var zeilen = document.querySelectorAll('.ns-sum__row');
      var vs = null;
      for (var i = 0; i < zeilen.length; i++) if (/Versand/.test(zeilen[i].textContent)) vs = zeilen[i];
      if (vs) {
        var wert = vs.lastElementChild ? vs.lastElementChild.textContent.trim() : '';
        // "inklusive", nicht "zzgl." (07.09.2026): der Betrag im Balken ist
        // cart.total_price PLUS Versand, der Versand steckt also schon
        // darin. Muss gleichlautend mit main-cart-footer.liquid bleiben,
        // sonst steht nach der ersten Mengenaenderung wieder der alte Satz.
        hinweis.textContent = frei ? 'Versand inklusive' : 'inklusive ' + wert + ' Versand';
      }
    }

    if (io) io.disconnect();
    if (!('IntersectionObserver' in window)) { bar.classList.add('is-on'); return; }

    var cta = q('#checkout');
    var fuss = q('footer, .footer, #shopify-section-footer');

    /* Der Balken darf erst kommen, wenn der Kassenknopf OBEN aus dem Bild
       gelaufen ist. "Nicht sichtbar" allein reicht nicht: beim Seitenaufbau
       steht der Knopf noch WEITER UNTEN und ist damit ebenfalls nicht
       sichtbar. Gemessen bei 390px, 1 Artikel: Summenkarte 699..1216 bei
       einem 844 hohen Fenster, der Knopf darunter — der Balken erschien
       sofort im ersten Bildschirm, obwohl der echte Knopf zwei Wischer
       entfernt war. Zwei Kaufknoepfe ohne Not.
       Deshalb zusaetzlich die Lage: bottom <= 0 heisst oberhalb des
       Fensters, also hat der Kunde daran vorbeigescrollt. */
    io = new IntersectionObserver(
      function (eintraege) {
        eintraege.forEach(function (e) {
          if (e.target === cta) ctaWeg = !e.isIntersecting && e.boundingClientRect.bottom <= 0;
          else fussDa = e.isIntersecting;
        });
        balken();
      },
      { threshold: 0 }
    );
    if (cta) io.observe(cta);
    if (fuss) io.observe(fuss);
    balken();
  }

  balkenBeobachten();
})();
